import {Charts} from './Charts';
import IDCRASChartsDataProvider from './contexts/IDCREASChartsDataContext'

const IDCREAS = () => {
    return (
        <IDCRASChartsDataProvider>
            <Charts />
        </IDCRASChartsDataProvider>
    );
};

export default IDCREAS;